import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import { StudyProgressContext } from '../../../Context';
import './StudyProgressBar.css'; 

const StudyProgressBar = () => {
    const { studyProgress } = useContext(StudyProgressContext);

    console.log("studyProgress is " + studyProgress);

    return (
        <div className="study-progress-bar-container">
            <motion.div
                className="study-progress-bar"
                initial={{ width: 0 }}
                animate={{ width: `${studyProgress || 0}%` }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
            >
                {/* <span className="progress-label">{`${studyProgress || 0}%`}</span> */}
            </motion.div>
        </div>
    );
};

export default StudyProgressBar;
